const isPerfHarness = () => {
  if (typeof window === 'undefined') return false
  const params = new URLSearchParams(window.location.search)
  return params.get('inject') === 'perf'
}

const container = document.getElementById('root')!

const boot = async () => {
  // Pass5 Task 11 (1.A.9.1) — install global error handlers as early as possible.
  const { installGlobalHandlers } = await import('./utils/errorReporting')
  installGlobalHandlers()

  if (isPerfHarness()) {
    const { mountPerfHarness } = await import('./perf/PerfHarnessApp')
    mountPerfHarness(container)
    return
  }

  const { mountApp } = await import('./appEntrypoint')
  mountApp(container)
}

void boot()
